// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //apiURL: 'https://localhost:44350/',  // Local development API URL
//  apiURL: 'https://stagingbadeloft.azurewebsites.net/', // Staging API URL
  apiURL: 'https://api.badeloft.app/', // Production API URL

  //redirectURL: 'http://localhost:1234/bade-loft/callback',  // Local development
 // redirectURL: 'https://badeloftstaging.azurewebsites.net/bade-loft/callback',  //Staging
  redirectURL: 'https://badeloft.app/bade-loft/callback',  // Production

  //appclientId: 'ABYS8oDbrDUYNZNFY26ZqEs47BXKICJEn5geXHBqrqHUNw84Vm', //staging
   appclientId: 'ABo7xbnkglfO3HusIzrHP93BKm3KkJFe8UJkWAVvQhduvgmtQC', //live
  //realmId: '9341452163662321', //staging
  realmId: '720160395' //live
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
